
import { reactive, ref, watch, defineComponent } from 'vue'
import { useRoute } from 'vue-router'
import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import FaqLists from '@/components/block/FaqLists.vue'
import Alert from '@/components/elements/Alert.vue'
import FaqCategories from '@/components/block/FaqCategories.vue'
import FaqContact from '@/components/block/FaqContact.vue'
import Loader from '@/components/elements/Loader.vue'
import { axiosSetting } from '@/utils/axiosSetting'

export default defineComponent({
  name: 'Faq',
  components: {
    HeadingLv1,
    HeadingLv3,
    FaqLists,
    Alert,
    FaqCategories,
    FaqContact,
    Loader
  },
  setup() {
    const state = reactive({
      loading: true
    })
    const lists = ref([])
    const route = useRoute()
    const ajax = axiosSetting('cms', 'block')

    const getLists = () => {
      ajax
        .get(
          `${process.env.VUE_APP_WPAPI_URL}wp-json/wp/v2/faq?faq_pickup_flag=1&per_page=5`
        )
        .then((res) => {
          // console.log(res.data)
          lists.value = res.data
        })
        .finally(() => {
          state.loading = false
        })
    }

    getLists()

    watch(
      () => route.path,
      () => {
        getLists()
      }
    )

    return {
      state,
      lists
    }
  }
})
